import React from 'react';
import { X, Tag, Clock } from 'lucide-react';

/**
 * ClusterDrawer — Detail view for a selected cluster.
 *
 * Props:
 *   cluster: { label, feature_area, item_count, items? }
 *   onClose: () => void
 */

const ClusterDrawer = ({ cluster, onClose }) => {
    if (!cluster) return null;

    const items = cluster.items || [];

    return (
        <>
            <div onClick={onClose} style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.2)',
                zIndex: 100,
            }} />
            <div style={{
                position: 'fixed', top: 0, right: 0, bottom: 0,
                width: 440, maxWidth: '90vw',
                background: '#fff', zIndex: 101,
                boxShadow: '-4px 0 24px rgba(0,0,0,0.12)',
                display: 'flex', flexDirection: 'column',
                animation: 'slideInRight 0.2s ease-out',
            }}>
                {/* Header */}
                <div style={{
                    padding: '16px 20px', borderBottom: '1px solid #e5e7eb',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                    <div>
                        <h3 style={{ fontSize: 15, fontWeight: 700, color: '#111827', margin: 0 }}>
                            {cluster.label || 'Cluster Detail'}
                        </h3>
                        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                            {cluster.feature_area && (
                                <span style={{
                                    fontSize: 10, fontWeight: 600,
                                    background: '#eef2ff', color: '#4f46e5',
                                    padding: '2px 8px', borderRadius: 4,
                                }}>
                                    {cluster.feature_area}
                                </span>
                            )}
                            <span style={{ fontSize: 11, color: '#6b7280' }}>
                                {cluster.item_count || 0} items
                            </span>
                        </div>
                    </div>
                    <button onClick={onClose} style={{
                        padding: 6, borderRadius: 8, border: 'none',
                        background: '#f1f5f9', cursor: 'pointer', color: '#64748b',
                    }}>
                        <X size={16} />
                    </button>
                </div>

                {/* Items */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
                    {items.length === 0 ? (
                        <div style={{
                            textAlign: 'center', padding: '40px 0',
                            color: '#94a3b8', fontSize: 13,
                        }}>
                            Detailed items are not yet available for this cluster.
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {items.map((item, i) => (
                                <div key={i} style={{
                                    padding: '12px 14px', borderRadius: 10,
                                    background: '#f8fafc', border: '1px solid #f1f5f9',
                                }}>
                                    <p style={{ fontSize: 13, color: '#374151', margin: 0, lineHeight: 1.5 }}>
                                        {item.message || item.text || JSON.stringify(item)}
                                    </p>
                                    <div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
                                        {item.category && (
                                            <span style={{
                                                fontSize: 10, display: 'flex', alignItems: 'center', gap: 3,
                                                color: '#6b7280',
                                            }}>
                                                <Tag size={10} /> {item.category}
                                            </span>
                                        )}
                                        {item.created_at && (
                                            <span style={{
                                                fontSize: 10, display: 'flex', alignItems: 'center', gap: 3,
                                                color: '#6b7280',
                                            }}>
                                                <Clock size={10} /> {new Date(item.created_at).toLocaleDateString()}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <style>{`
                @keyframes slideInRight {
                    from { transform: translateX(100%); }
                    to { transform: translateX(0); }
                }
            `}</style>
        </>
    );
};

export default ClusterDrawer;
